import "./../styles.scss";
import "./../styles.scss";

import { EditOutlined } from "@ant-design/icons";
import { Select } from "antd";
import { Dropdown, notification, Pagination, Tooltip } from "antd";
import { reservedChannelInputTypeOptions, ROLE } from "constants/phase";
import { SocketContext } from "context/socket";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useOutletContext, useSearchParams } from "react-router-dom";
import Select2 from "react-select";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import DeleteModal from "../../../components/common/Modals/component";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import TheeDotsIcon from "../../../components/icons/TheeDotsIcon";
import EditReservedChannel from "./EditReservedChannel";

const { Option } = Select;

const AddReservedChannle = (props) => {
  const {
    usersDetails,
    setUserSearch,
    userSearch,
    userId,
    setLoder,
    loder,
    user,
    setNotify,
    notify,
    allUsers,
    setAllUsers,
    getInviteUser,
    fetchUsersByUserIds,
    createReservedChannle,
    editReservedChannel,
    listReservedChannel,
    deleteReservedChannel,
    getOrgDetails,
    getOrganizationsByIds,
  } = props;
  const firstRef = useRef(true);
  const { entityId, currentRole } = useOutletContext();
  const { webhookSocket } = useContext(SocketContext);
  const [delLoder, setDelLoder] = useState(false);
  const [options, setoptions] = useState([]);
  const [count, setCount] = useState(0);
  const [editChannelDetail, setEditChannelDetail] = useState(null);
  const [channels, setChannels] = useState([]);
  const [channelId, setChannelId] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [settingsRecordsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [selectedInputType, setSelectedInputType] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const updatedSearchParams = useMemo(() => new URLSearchParams(searchParams.toString()), [searchParams]);

  const handleCopy = () => {
    notification["success"]({ message: "Copied to clipboard" });
  };

  const [initialState] = useState({
    channelName: "",
    channelId: "",
    flowName: "",
    flowId: "",
    inputId: "",
    outboundIp: "",
    region: "",
    user: "",
    inputType: "",
    count: "",
    formType: "manual",
  });
  const [selectOrganization, setSelectOrganization] = useState([]);
  const [organizationLists, setOrganizationLists] = useState([]);

  //Get All OrganizationsLists

  const openModal = () => {
    setIsOpen(true);
  };

  const delOpen = (data) => {
    setChannelId(data?._id);
    setDeleteModalOpen(true);
  };

  const closeModal = () => {
    setSelectedUser([]);
    setNotify(false);
    setIsOpen(false);
  };
  const delclose = () => {
    setDeleteModalOpen(false);
  };

  const deleteChannelModel = async () => {
    setDelLoder(true);
    const { value } = await deleteReservedChannel(channelId);
    if (value?.status) {
      delclose();
      notification["success"]({ message: value.message });
    } else {
      delclose();
      notification["error"]({ message: value.message });
    }
    fetchChannels();
    setDelLoder(false);
  };

  const handleChange = (e) => {
    setSelectOrganization(e);
  };

  useEffect(() => {
    const options = [];
    organizationLists &&
      organizationLists.map((org) => {
        options.push({ value: org?.organizationId, label: org?.name });
      });
    setoptions(options);
  }, [organizationLists]);

  useEffect(() => {
    if (updatedSearchParams.get("selectedInputType")) {
      setSelectedInputType(JSON.parse(updatedSearchParams.get("selectedInputType")));
    }
  }, [searchParams, updatedSearchParams]);

  useEffect(() => {
    getInviteUser(false);
  }, [count]);

  useEffect(() => {
    fetchChannels();
  }, [activePage, selectedInputType]);

  const fetchChannels = async () => {
    setLoader(true);
    const data = await listReservedChannel({
      entityId,
      page_no: activePage,
      limit: 10,
      inputType: selectedInputType?.value,
    });
    if (data?.value?.status) {
      setTotalCount(data?.value?.channelCount);
      setChannels(data?.value?.data);
    } else {
      notification["error"]({ message: data?.value?.message });
    }
    setLoader(false);
  };

  useEffect(() => {
    if (firstRef.current) {
      firstRef.current = false;
    } else {
      const timer = setTimeout(() => {
        setCount(count + 1);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [userSearch]);

  useEffect(() => {
    webhookSocket.on("autoChannelCreation", () => {
      notification["success"]({ message: `Channels created successfully` });
      fetchChannels();
    });

    return () => {
      webhookSocket.off("autoChannelCreation");
    };
  }, [webhookSocket]);

  const handleSubmit = async (values) => {
    setLoder(true);
    const { value } = await createReservedChannle(
      values.formType === "manual"
        ? {
            channelName: values.inputType !== "SRT_PULL" ? values.channelName : values.flowName,
            channelId: values.inputType !== "SRT_PULL" ? values.channelId : "",
            flowId: values.inputType === "SRT_PULL" ? values.flowId : "",
            inputId: values.inputType !== "SRT_PULL" ? values.inputId : "",
            outboundIp: values.outboundIp,
            region: values.region,
            type: "manual",
            user: selectedUser?.value,
            inputType: values.inputType,
          }
        : {
            channelName: values.inputType === "SRT_PULL" ? values.flowName : values.channelName,
            count: parseInt(values.count),
            region: values.region,
            inputType: values.inputType,
            type: "auto",
          },
    );
    if (value.status == true) {
      notification["success"]({ message: value.message });
      setNotify(false);
      closeModal();
    } else if (value.status == false && value.message == "Channel Already Exists!") {
      setNotify(true);
    } else {
      notification["error"]({ message: value.message });
    }
    fetchChannels();
    setSelectedUser([]);
    setLoder(false);
  };

  const EditOpen = () => {
    setEditOpen(true);
  };

  const handleClick = async (data) => {
    setEditChannelDetail(data);
    if (data?.user?.length !== 0) {
      fetchUsersByUserIds([data?.user]);
    }
  };

  const handlChange = (setFieldValue, e) => {
    if (e?.target?.name) {
      setFieldValue(e.target.name, e.target.value);
    }
    setNotify(false);
  };

  const actions = {
    edit_reserved_channel: true,
    delete_reserved_channel: true,
  };

  const handleChannelTableAction = (profileFeature, menuItems) => {
    for (const key in actions) {
      if (profileFeature.hasOwnProperty(key) && profileFeature?.[key]) {
        switch (key) {
          case "edit_reserved_channel":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    EditOpen();
                  }}
                >
                  <EditOutlined />
                  <span>{`${currentRole !== ROLE.SUPER_ADMIN ? "View" : "Edit"} Channel`}</span>
                </a>
              ),
              key: "1",
            });
            break;
          case "delete_reserved_channel":
            menuItems.push({
              label: (
                <a
                  onClick={() => {
                    delOpen(editChannelDetail);
                  }}
                >
                  <DeleteIcon />
                  <span>Delete</span>
                </a>
              ),
              key: "2",
            });
            break;
        }
      }
    }
  };

  const handlePageChange = (current) => {
    setActivePage(current);
  };

  const handleChannel = () => {
    notification["warning"]({ message: "Channel in use, Please try later!" });
  };

  const handleTemplateChange = (e) => {
    setSelectedInputType(e);
    updatedSearchParams.set("selectedInputType", JSON.stringify(e));
    setSearchParams(updatedSearchParams);
  };

  return (
    <>
      <EditReservedChannel
        options={options}
        setEditOpen={setEditOpen}
        modalIsOpen={modalIsOpen}
        initialState={initialState}
        allUsers={allUsers}
        getInviteUser={getInviteUser}
        setAllUsers={setAllUsers}
        handleChange={handleChange}
        setUserSearch={setUserSearch}
        loder={loder}
        notify={notify}
        setNotify={setNotify}
        userSearch={userSearch}
        setLoder={setLoder}
        editReservedChannel={editReservedChannel}
        fetchChannels={fetchChannels}
        editOpen={editOpen}
        editChannelDetail={editChannelDetail}
        user={user}
        getOrganizationsByIds={getOrganizationsByIds}
        entityId={entityId}
        getOrgDetails={getOrgDetails}
      />
      <DeleteModal
        setDeleteModalOpen={setDeleteModalOpen}
        modalIsOpen={delmodalOpen}
        loder={delLoder}
        deleteComanModel={deleteChannelModel}
        header="Delete"
        content="Are you sure you want to delete?"
      />

      {/* Reserved Channel List page */}
      <div className="col-md-12">
        <div className="border-block groups-block overflow-visible">
          <div className="left-block">
            <h4 className="title-sm-t">Reserved Channels</h4>
          </div>
          <div className="template-filters">
            <div className="select-container">
              <Select2
                bordered={false}
                name="templateType"
                placeholder="Select Input Type"
                value={selectedInputType}
                className="select"
                isClearable={true}
                onChange={(e) => {
                  handleTemplateChange(e);
                }}
                options={reservedChannelInputTypeOptions}
              />
            </div>
            {currentRole === ROLE.SUPER_ADMIN && (
              <div className="right-btn-block">
                <div className="button-container">
                  <AccessControl code="add_reserved_channel" page="organization-profile">
                    <button className="btn btn-primary" onClick={openModal}>
                      Add Reserved Channels
                    </button>
                  </AccessControl>
                </div>
              </div>
            )}
          </div>
        </div>
        <br />
        <div className="border-block mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="table-resposive table-container user-management-table">
                <table className="table">
                  <>
                    <thead>
                      <tr>
                        <th>Channel Name</th>
                        <th>Server Key</th>
                        <th>Channel Id</th>
                        <th>URL</th>
                        <th>Input Id</th>
                        <th>Flow Id</th>
                        <th>Outbound Ip</th>
                        <th>Region</th>
                        <th style={{ textAlign: "center" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loader ? (
                        <>
                          <tr>
                            <td colSpan="7">
                              <div className="text-center  pt-5 pb-5">
                                <h3>Fetching Reserved Channels</h3>
                              </div>
                            </td>
                          </tr>
                        </>
                      ) : (
                        <>
                          {channels?.length ? (
                            channels?.map((data, index) => {
                              return (
                                <tr key={data?._id}>
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    <Tooltip
                                      title={data?.channelName}
                                      placement={"bottomLeft"}
                                      className="word-break-two title_Pascal"
                                    >
                                      {data?.channelName}
                                    </Tooltip>
                                  </td>
                                  <td>{data?.serverKey[0]}</td>
                                  <td>{data?.channelId}</td>
                                  <td style={{ cursor: "pointer" }}>
                                    {data?.url && data?.url?.length > 0 && (
                                      <CopyToClipboard text={data?.url} onCopy={handleCopy}>
                                        <Tooltip title={data?.url}>
                                          {data?.url?.length > 20 ? `${data?.url?.slice(0, 20)}...` : data?.url}
                                        </Tooltip>
                                      </CopyToClipboard>
                                    )}
                                  </td>
                                  <td>{data?.inputId}</td>
                                  <td style={{ cursor: "pointer" }}>
                                    {data?.flowId && data?.flowId?.length > 0 && (
                                      <CopyToClipboard text={data?.flowId} onCopy={handleCopy}>
                                        <Tooltip title={data?.flowId}>
                                          {data?.flowId?.length > 20
                                            ? `${data?.flowId?.slice(0, 20)}...`
                                            : data?.flowId}
                                        </Tooltip>
                                      </CopyToClipboard>
                                    )}
                                  </td>
                                  <td>{data?.outboundIp}</td>
                                  <td>{data?.region}</td>

                                  <td>
                                    <div className="table-action-block text-center">
                                      {data?.isChannelTaken ? (
                                        <a className="ant-dropdown-link" onClick={(e) => handleChannel()}>
                                          <TheeDotsIcon />
                                        </a>
                                      ) : (
                                        <Dropdown
                                          onClick={() => {
                                            handleClick(data);
                                          }}
                                          className=""
                                          overlay={
                                            <AccessControl
                                              code="menuItem"
                                              page="organization-profile"
                                              handleTableAction={handleChannelTableAction}
                                            />
                                          }
                                          trigger={["click"]}
                                          overlayClassName={"tableActionBlock"}
                                          placement={"bottomRight"}
                                        >
                                          <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                                            <TheeDotsIcon />
                                          </a>
                                        </Dropdown>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <>
                              <tr>
                                <td colSpan="7">
                                  <div className="text-center  pt-5 pb-5">
                                    <h3>No Channels found</h3>
                                  </div>
                                </td>
                              </tr>
                            </>
                          )}
                        </>
                      )}
                    </tbody>
                  </>
                  <tfoot></tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>

        <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={settingsRecordsPerPage}
          onChange={handlePageChange}
          total={totalCount}
          className="text-center mt-3"
        />
      </div>
    </>
  );
};

export default AddReservedChannle;
